<ul class="side-nav-profile" *ngIf="isLogIn">
    <li *ngFor="let data of profileSideBarData;let i=index"
        [ngClass]="{'active': (utils.profileSideActiveIndex == i && !notShowActiveClass)}">
        <a [routerLink]="data.link" (click)="routeHandler()" class="arrow">
            <img  loading="lazy" [src]="environment?.blobUrl + data.icon" [alt]="data.title">
            <p>{{data.title}}</p>
            <span *ngIf="data.value">{{data.value}}</span>
        </a>
    </li>
</ul>

<ul class="sign-out side-nav-profile" *ngIf="!hideLogoutButton">
    <li *ngIf="isLogIn" (click)="onSignOut()">
        <a href="javascript:void(0)">
            <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/signOut.svg'" alt="Sign out | Luminous">
            <p>Sign out</p>
        </a>
    </li>
</ul>
